exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-option {\n  color: #7b7b7b;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  font-size: 13px; }\n  .radio-option img {\n    width: 15px;\n    margin-bottom: 4px;\n    margin-top: 4px; }\n  .radio-option.active {\n    color: #34b3e8; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/shared/radio-selector/radio-selector.component.scss
// module id = ../../../../../src/app/shared/radio-selector/radio-selector.component.scss
// module chunks = 1